import { RouteLocationNormalized } from "vue-router";

import { getAuthClient } from "@/modules/authorisation/authClient";
import { useAuthorisationStore } from "@/modules/authorisation/authorisationStore";

export default async function redirectToLoginIfUnauthorised(to: RouteLocationNormalized) {
  const authorisationStore = useAuthorisationStore();

  if (!authorisationStore.redirectToAfterLoginUrl) {
    authorisationStore.redirectToAfterLoginUrl = to.fullPath;
  }

  const authClient = await getAuthClient();
  const token = await authClient.getAccessToken();
  if (!token) {
    return { name: "auth.login" };
  }
  return undefined;
}
